import {View} from 'react-native';
import * as React from 'react';
import {useTheme} from '../../theme';
import {Props} from './model';
import {Text} from '../text';
import {useStyles} from '../../hooks/styles';

export const OrDelimiter = (props: Props) => {
  const theme = useTheme();
  const styles = useStyles(
    () => ({
      container: {
        marginTop: props.marginTop ?? 30,
        marginBottom: props.marginBottom ?? 30,
        flexDirection: 'row',
        width: '100%',
        alignItems: 'center',
      },
      text: {
        paddingHorizontal: 19,
        color: theme.color.labelText,
      },
    }),
    [theme],
  );

  return (
    <View style={styles.container}>
      <View style={[theme.hr, {flex: 1}]} />
      <Text style={styles.text} type='label'>
        или
      </Text>
      <View style={[theme.hr, {flex: 1}]} />
    </View>
  );
};
